import { Component, Input, inject } from '@angular/core';
import { ClientReferralTask } from 'app/core/models/client-referral-task.model';
import { AuthenticationService } from 'app/core/services/authentication.service';

import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-client-task-nav',
    templateUrl: './client-task-nav.component.html',
    styleUrls: ['./client-task-nav.component.scss'],
    imports: [RouterLinkActive, RouterLink, MatIcon]
})
export class ClientTaskNavComponent {
  private authService = inject(AuthenticationService);

  @Input() baseUrl: string;
  @Input() task: ClientReferralTask;

  public get isCaptureAdmin() {
    return this.authService.isCaptureAdminUser;
  }

  public get detailsUrl() {
    return this.baseUrl;
  }

  public get historyItemsUrl() {
    return `${this.baseUrl}/history-items`;
  }
}
